import { LoaderFunction } from 'react-router-dom';

const isValidProductId = (id: string) => {
	return /^\d+$/.test(id);
};

export const chatLoader: LoaderFunction = ({ params }): null => {
	const { productId } = params;

	if (productId && !isValidProductId(productId)) {
		throw new Error('Invalid product ID');
	}
	return null;
};
